import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {pageSliceInitialState} from "@Reducers/constants/pageSliceInitial.state";
import PageErrorType from "@/types/pageSlice/PageError.type";


const pageSlice = createSlice({
    name: 'page',
    initialState: pageSliceInitialState,
    reducers: {
        setLocale: (state, action) => (
            {...state, locale: action.payload}
        ),

        setPageLayout: (state, action) => ({
            ...state,
            ...action.payload,
        }),

        activatePopup: (state, action) => (
            {...state, activePopup: action.payload}
        ),

        setActiveStickyContainerHeight: (state, action) => ({
            ...state,
            activeStickyContainerHeight: action.payload,
        }),

        setIs404Page: (state, action: PayloadAction<boolean>) => ({
            ...state,
            is404Page: action.payload,
        }),

        setHeaderBackgroundImageRgbPixelData: (state, action: PayloadAction<Uint8ClampedArray[]>) => ({
            ...state,
            headerBackgroundImageRgbPixelData: action.payload,
        }),

        setError: (state, action: PayloadAction<PageErrorType | undefined>) => {
            state.error = action.payload
        },

        clear: () => pageSliceInitialState,
    },
})

export const {
    setLocale,
    setPageLayout,
    activatePopup,
    setError,
    setActiveStickyContainerHeight,
    setIs404Page,
    setHeaderBackgroundImageRgbPixelData,
} = pageSlice.actions

export default pageSlice.reducer